import { router } from 'expo-router';
import {
    Beef,
    Coffee,
    Cookie,
    Croissant,
    Egg,
    Fish,
    Flame,
    IceCream,
    Leaf,
    Pizza,
    Salad,
    Sandwich,
    Soup,
    UtensilsCrossed,
    Wine,
    type LucideIcon,
} from 'lucide-react-native';
import React from 'react';
import { Pressable, View } from 'react-native';
import { Text } from '@/components/ui/text';

interface CuisineChipProps {
  cuisine: string;
}

// Map cuisine names to Lucide icons
const CUISINE_ICONS: Record<string, LucideIcon> = {
  // European
  italian: Pizza,
  french: Croissant,
  mediterranean: Wine,
  greek: Wine,
  spanish: Wine,
  british: Sandwich,
  german: Sandwich,

  // Asian
  japanese: Fish,
  chinese: Soup,
  korean: Soup,
  thai: Soup,
  vietnamese: Soup,
  indian: Flame,

  // Americas
  american: Sandwich,
  mexican: Flame,
  brazilian: Beef,
  cajun: Fish,
  caribbean: Fish,

  // Middle Eastern
  'middle eastern': Flame,
  turkish: Flame,
  lebanese: Flame,
  moroccan: Flame,

  // Categories
  seafood: Fish,
  steakhouse: Beef,
  bbq: Flame,
  vegetarian: Salad,
  vegan: Leaf,
  bakery: Cookie,
  dessert: IceCream,
  cafe: Coffee,
  breakfast: Egg,
  'fast food': Sandwich,
  pizza: Pizza,
  sushi: Fish,
};

const getCuisineIcon = (cuisine: string): LucideIcon => {
  const normalized = cuisine.toLowerCase().trim();
  return CUISINE_ICONS[normalized] || UtensilsCrossed;
};

// Convert cuisine name to title case
const toTitleCase = (str: string): string => {
  return str
    .toLowerCase()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const CuisineChip = React.memo(({ cuisine }: CuisineChipProps) => {
  const displayName = toTitleCase(cuisine);
  const IconComponent = getCuisineIcon(cuisine);

  const handlePress = () => {
    router.push({
      pathname: '/(root)/cuisine/[cuisine]',
      params: { cuisine },
    } as any);
  };

  return (
    <Pressable className="items-center mr-4 w-20" onPress={handlePress}>
      <View className="w-14 h-14 rounded-xl items-center justify-center mb-1 shadow-sm border bg-surface border-border">
        <IconComponent size={28} className="text-foreground" strokeWidth={1.5} />
      </View>
      <Text
        className="text-xs text-center text-foreground"
        numberOfLines={2}
      >
        {displayName}
      </Text>
    </Pressable>
  );
});

CuisineChip.displayName = 'CuisineChip';

export default CuisineChip;
